import React from "react";

/**
 * RelatedBlock — a slot-based "you might also need" strip.
 *
 * Props:
 *  - groups: [{ eyebrow: string, items: ReactNode[] }]
 *      Each group renders as: eyebrow label + horizontal list of cards.
 *      `items` are pre-rendered cards (ServiceCard, CaseStudyCard, etc.)
 *  - title?: string                        Section headline. Defaults to "You might also be after".
 *  - className?: string
 */
const RelatedBlock = ({ groups = [], title = "You might also be after", className = "" }) => {
  const nonEmpty = groups.filter((g) => g.items && g.items.length);
  if (!nonEmpty.length) return null;

  return (
    <section
      className={`max-w-7xl mx-auto px-5 lg:px-10 mt-24 lg:mt-32 mb-24 ${className}`}
      data-testid="related-block"
    >
      <p className="eyebrow">Related</p>
      <h2
        className="font-display mt-4 text-white"
        style={{ fontSize: "clamp(28px, 3.4vw, 42px)", lineHeight: 1 }}
      >
        {title}
      </h2>

      <div className="mt-10 space-y-12">
        {nonEmpty.map((group, gi) => (
          <div key={`${group.eyebrow}-${gi}`} data-testid={`related-group-${gi}`}>
            <p className="eyebrow">{group.eyebrow}</p>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {group.items.map((item, ii) => (
                <React.Fragment key={ii}>{item}</React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RelatedBlock;
